import { styled } from '@mui/material/styles'
import { Box, Tabs } from '@mui/material'

export const StyledBoxContainer = styled(Box)(({ theme }) => ({
  padding: '1rem',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,
  borderRadius: '0.5rem',
}))

export const StyledTabsContent = styled(Box)(({ theme }) => ({
  padding: '1rem',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,
  borderTopLeftRadius: '0.2rem',
  borderTopRightRadius: '0.2rem',
  borderBottomRightRadius: '0.5rem',
  borderBottomLeftRadius: '0.5rem',
  borderTop: '3px solid',
  borderColor: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}))

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiButtonBase-root': {
    minHeight: '3rem',
  },
  '& .MuiTab-textColorPrimary': {
    color: theme.palette.text.primary,
  },
  '& .MuiTabs-flexContainer': {
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .Mui-selected': {
    borderBottom: '2px solid',
    color: theme.palette.primary.main,
  },
}))
